// Port of api/fuel/app/classes/controller/api/monty/listing/remove.php
import {
	LIST_TYPE_MANUAL,
	currentEdition,
	currentUserId,
	loadListingEdition,
	loadOwnedListing,
	parseGameIndex,
	persist,
	saveEditionGames,
	unauthorised,
	uniqueIndex
} from './shared'

export default function(params) {
	var userId = currentUserId(params)
	var listing = loadOwnedListing(userId, params.list)
	var edition = null
	var removeIndex = uniqueIndex(params.games || [])
	var index = []

	if (!userId) return unauthorised()
	if (!listing || listing.get_type() !== LIST_TYPE_MANUAL) return unauthorised()

	edition = loadListingEdition(listing, params.edition) || currentEdition(listing)
	if (!edition) return Promise.reject({ error: 120, offline: true })

	index = parseGameIndex(edition.get_index_games()).filter(function(gameId) {
		return removeIndex.indexOf(gameId) === -1
	})

	saveEditionGames(edition.get_id(), index)
	return persist({})
}
